module.exports = __webpack_public_path__ + "static_pc/img/charTitle.544d833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/charTitle.png
// module id = nI3z
// module chunks = 1